import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.listener = this.showToast.bind(this)
    window.addEventListener("notifications:received", this.listener)
  }

  disconnect() {
    window.removeEventListener("notifications:received", this.listener)
  }

  showToast(event) {
    const { title, body } = event.detail
    const toast = document.createElement("div")
    const heading = document.createElement("p")
    const content = document.createElement("p")

    toast.className = "rounded-lg border border-slate-200 bg-white p-3 shadow-lg"
    heading.className = "text-sm font-semibold text-slate-900"
    content.className = "mt-1 text-sm text-slate-700"

    heading.textContent = title || "Notification"
    content.textContent = body || ""

    toast.appendChild(heading)
    toast.appendChild(content)

    this.element.appendChild(toast)
    setTimeout(() => toast.remove(), 5000)
  }
}
